import { Component, Injector, inject } from "@angular/core";
import { DatePipe } from "@angular/common";
import { FilterDataType, MatTableCrudComponent } from "../../../shared/components/mat-table-crud/mat-table-crud.component";
import { MatTableCrudService } from "../../../shared/components/mat-table-crud/mat-table-crud.service";
import { AuthorisationService } from "../../../shared/services/authorisation.service";
import { ConfigurationService } from "../../../shared/services/configuration.service";
import { CategoryExclusivity } from "../../calendars/calendars.models";
import { AdministrationService } from '../administration.service';
import { CategoryExclusivityEditComponent } from "./category-exclusivity-edit.component";
import { MatPaginatorModule } from "@angular/material/paginator";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { QueryClient } from "@tanstack/angular-query-experimental";
import { Subscription } from "rxjs";


@Component({
    templateUrl: './category-exclusivities.component.html',
    styleUrls: ['./category-exclusivities.component.scss', '../../../shared/components/mat-table-crud/mat-table-crud.component.scss'],
    providers: [MatTableCrudService],
    standalone: true,
    imports: [MatCardModule, MatButtonModule, MatIconModule, MatTableModule, MatSortModule, MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule, MatPaginatorModule, DatePipe]
})
export class CategoryExclusivitiesComponent extends MatTableCrudComponent<CategoryExclusivity>
{
  public PodcastNameFilter: any;
  public ClientNameFilter: any;
  public ProductCategoryNameFilter: any;

  private queryClient = inject(QueryClient);

  private onDataFetchedSubscription: Subscription;

  constructor(public authorisationService: AuthorisationService, protected injector: Injector, public configurationService: ConfigurationService, public administrationService: AdministrationService)
  {
    super(injector,
      CategoryExclusivityEditComponent,
      CategoryExclusivityEditComponent,
      CategoryExclusivityEditComponent,
      "CreateCategoryExclusivity",
      "DeleteCategoryExclusivity",
      "GetCategoryExclusivities",
      "UpdateCategoryExclusivity",
      configurationService.cbSettings().adminServiceUrl,
      configurationService.cbSettings().adminServiceUrl,
      configurationService.cbSettings().adminServiceUrl,
      configurationService.cbSettings().adminServiceUrl);

    this.displayedColumns = ['Id', 'PodcastName', 'ClientName', 'ProductCategoryName', 'StartDate', 'EndDate'];
    this.filteredValues = [
      { Field: "PodcastName", Value: "", Path: "", DataType: FilterDataType.String },
      { Field: "ClientName", Value: "", Path: "", DataType: FilterDataType.String },
      { Field: "ProductCategoryName", Value: "", Path: "", DataType: FilterDataType.String }
    ];

    this.dialogConfig.disableClose = true;
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.hasBackdrop = true;
    this.dialogConfig.width = "45rem";

    this.CanAdd = this.authorisationService.hasPermission(this.authorisationService.Permissions.AddCategoryExclusivities);
    this.CanEdit = this.authorisationService.hasPermission(this.authorisationService.Permissions.EditCategoryExclusivities);
    this.CanDelete = this.authorisationService.hasPermission(this.authorisationService.Permissions.DeleteCategoryExclusivities);
  }

  ngOnInit(): void
  {
    super.ngOnInit();

    this.onDataFetchedSubscription = this.mtCrudService.OnDataFetched.subscribe((result: any) =>
    {
      this.queryClient.invalidateQueries({
        type: "all", exact: false, predicate: (query: any) =>
        {
          return query.queryKey[0] == "CategoryExclusivities";
        }
      });
    });
  }

  deleteItem(event: any, categoryExclusivity: CategoryExclusivity)
  {
    this.deleteConfirmationMessage = `Are you sure you want to delete this category exclusivity (${categoryExclusivity.PodcastName} - ${categoryExclusivity.ClientName} - ${categoryExclusivity.ProductCategoryName})?`;
    this.deleteHeaderText = "Delete Category Exclusivity?";

    super.deleteItem(event, categoryExclusivity);
  }

  ngOnDestroy()
  {
    // prevent memory leak when component destroyed
    if (this.onDataFetchedSubscription)
    {
      this.onDataFetchedSubscription.unsubscribe();
    }

    super.ngOnDestroy();
  }
}
